import { SkeletonText } from '@ovotech/nebula';
import React from 'react';

export const AccountInfoLoading = () => {
  return <SkeletonText data-testid="account-info-loading" lines={2} />;
};
